<nb-card [ngStyle]="{'height': cardHeight}" [ngClass]="{'no-border' : !borderCard, 'ti-fit-content': isFitContent}">
  <nb-card-body>
    <div class="row show-grid alertMess" *ngIf="showAlertMessage">
      <nb-alert status="{{messTypeAlert}}" class="barAlertMess">{{messTextAlert}}</nb-alert>
    </div>
    <div *ngIf="showTwoColumns">
      <div class="row show-grid animate__animated animate__bounceIn">
        <div class="col-md-12" style="padding-left: 10px;padding-right: 10px;">
          <div class="ti-toolbar form-modern">
            <div class="ti-actions-left">
              <button-text *ngIf="tableData.buttonsTable" [buttonText]="tableData.buttonsTable"></button-text>
              <button *ngIf="tableData.reloadButton.show" class="btn btn-outline-primary btn-icon reload"
                      [nbTooltip]="tableData.reloadButton.title" (click)="reloadData()" type="button">
                <i class="fas fa-sync-alt"></i>
              </button>
              <button-icon *ngIf="tableData.optionsTable && !isMobile" [buttonIcon]="tableData.optionsTable"
                           (buttonClick)="buttonClicked($event)"></button-icon>
            </div>
            <div class="ti-actions-right">
              <calendar-label *ngIf="tableData.calendarItem" [calendarData]="tableData.calendarItem"
                              (calendarButtonClick)="makeProcess($event)"
                              (startDateChange)="startDateChange($event)"
                              (endDateChange)="endDateChange($event)"></calendar-label>
              <input-search *ngIf="tableData.searchData" [inputSearchData]="tableData.searchData"
                            (dataSearch)="dataSearch($event)"></input-search>
            </div>
          </div>
        </div>
        <div class="col-md-12" style="padding-left: 0;display: flow-root;text-align: right; padding-right: 0;">
          <div class="ti-filters">
            <div *ngFor="let button of tableData.filtersParamns; let e = index" class="card filter-paramns"
                 (click)="addParams(button , e)"
                 [ngClass]="{'filter-selected': button.selected}">
              <div class="card-header" [nbTooltip]="button.title">{{button.title}}</div>
              <div class="card-body" [nbTooltip]="button.value">{{button.value}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="showOneColumn">
      <div class="row show-grid animate__animated animate__bounceIn">
        <div class="col-md-12">
          <div class="ti-toolbar form-modern">
            <div class="ti-actions-left">
              <button-text *ngIf="tableData.buttonsTable" [buttonText]="tableData.buttonsTable"></button-text>
              <button *ngIf="tableData.reloadButton.show"
                      class="btn btn-outline-primary btn-icon animate__animated animate__bounceIn reload"
                      [nbTooltip]="tableData.reloadButton.title"
                      (click)="reloadData()" type="button">
                <i class="fas fa-sync-alt"></i>
              </button>
              <button-icon *ngIf="tableData.optionsTable && !isMobile" [buttonIcon]="tableData.optionsTable"
                           (buttonClick)="buttonClicked($event)"></button-icon>
            </div>
            <div class="ti-actions-right">
              <calendar-label *ngIf="tableData.calendarItem" [calendarData]="tableData.calendarItem"
                              (calendarButtonClick)="makeProcess($event)"
                              (startDateChange)="startDateChange($event)"
                              (endDateChange)="endDateChange($event)"></calendar-label>
              <input-search *ngIf="tableData.searchData" [inputSearchData]="tableData.searchData"
                            (dataSearch)="dataSearch($event)"></input-search>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="showTwoRows">
      <div class="row show-grid animate__animated animate__bounceIn" *ngIf="tableData.filtersParamns" style="display: flow-root;text-align: center;">

        <!--<ngx-slick-carousel class="carousel"
                            #slickModal="slick-carousel"
                            [config]="slideConfig">-->
        <div *ngFor="let button of tableData.filtersParamns; let e = index" class="card filter-paramns slide"
             style="width: 16%;" (click)="addParams(button , e)"
             [ngClass]="{'filter-selected': button.selected}">
          <div class="card-header" [nbTooltip]="button.title">{{button.title}}</div>
          <div class="card-body" [nbTooltip]="button.value">{{button.value}}</div>
        </div>
        <!--</ngx-slick-carousel>-->
      </div>
      <div class="row show-grid animate__animated animate__bounceIn">
        <div class="col-md-12">
          <div class="ti-toolbar form-modern">
            <div class="ti-actions-left">
              <button-text *ngIf="tableData.buttonsTable" [buttonText]="tableData.buttonsTable"></button-text>
              <button *ngIf="tableData.reloadButton.show"
                      class="btn btn-outline-primary btn-icon animate__animated animate__bounceIn reload"
                      [nbTooltip]="tableData.reloadButton.title"
                      (click)="reloadData()" type="button">
                <i class="fas fa-sync-alt"></i>
              </button>
              <button-icon *ngIf="tableData.optionsTable && !isMobile" [buttonIcon]="tableData.optionsTable"
                           (buttonClick)="buttonClicked($event)"></button-icon>
            </div>
            <div class="ti-actions-right">
              <calendar-label *ngIf="tableData.calendarItem" [calendarData]="tableData.calendarItem"
                              (calendarButtonClick)="makeProcess($event)"
                              (startDateChange)="startDateChange($event)"
                              (endDateChange)="endDateChange($event)"></calendar-label>
              <input-search *ngIf="tableData.searchData" [inputSearchData]="tableData.searchData"
                            (dataSearch)="dataSearch($event)"></input-search>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Vista en tarjetas para móvil: misma info, acciones disponibles -->
    <div *ngIf="isMobile && showTable" class="table-index-mobile-cards">
      <p *ngIf="dataFillTable?.length === 0 && mobileDataLoaded" class="mobile-no-rows">{{ noRowsToShow }}</p>
      <div *ngIf="tableData.optionsTable?.length && showCheckButton" class="ti-toolbar ti-toolbar-mobile">
        <button-icon [buttonIcon]="tableData.optionsTable" (buttonClick)="onCardOptionClickFromBar($event)"></button-icon>
      </div>
      <div class="mobile-cards-list" *ngIf="dataFillTable?.length">
        <div *ngFor="let card of mobileCards; let i = index" class="mobile-card"
             [class.mobile-card-selected]="isCardSelected(i)"
             (click)="onCardClicked(card.row)">
          <div class="mobile-card-header" *ngIf="showCheckButton || tableData.optionsTable?.length">
            <label *ngIf="showCheckButton" class="mobile-card-check" (click)="$event.stopPropagation()">
              <input type="checkbox" [checked]="isCardSelected(i)" (change)="toggleCardSelection(card.row, i); $event.stopPropagation()">
            </label>
            <div class="mobile-card-actions" *ngIf="tableData.optionsTable?.length" (click)="$event.stopPropagation()">
              <button type="button" class="btn btn-sm btn-outline-primary mobile-actions-btn"
                      [class.mobile-actions-icon]="!!opt.icon"
                      [attr.aria-label]="opt.title || 'Acción'" [nbTooltip]="opt.title || 'Acción'"
                      *ngFor="let opt of tableData.optionsTable"
                      (click)="onCardOptionClick(opt, card.row)">
                <i *ngIf="opt.icon; else optText" [ngClass]="opt.icon"></i>
                <ng-template #optText>{{ opt.title || 'Acción' }}</ng-template>
              </button>
            </div>
          </div>
          <div class="mobile-card-body">
            <div *ngFor="let cell of card.cells" class="mobile-card-row">
              <span class="mobile-card-label" lang="es">{{ cell.label }}</span>
              <span class="mobile-card-value" [innerHTML]="cell.html"></span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Tabla AG-Grid: solo en escritorio; en móvil los datos se cargan con loadDataForMobile() -->
    <div class="table-index-grid-wrapper" *ngIf="showTable && !isMobile">
      <ag-grid-angular
        [style.height]="gridHeight"
        style="width:100%"
        class="ag-theme-balham animate__animated animate__backInRight"
        [gridOptions]="gridOptions"
        (gridReady)="onGridReady($event)"
        (cellEditingStopped)="onCellEditingStopped($event)"
        (cellClicked)="onCellClicked($event)"
        [components]="components"
        [suppressAggFuncInHeader]="true"
        [localeText]="localeText"
        [pagination]="!serverSide"
        [animateRows]="true"
        [paginationAutoPageSize]="!serverSide"
      >
      </ag-grid-angular>
    </div>
    <!-- Paginación en servidor -->
    <div class="ti-server-pager" *ngIf="serverSide && showTable">
      <span class="ti-pager-info">{{serverFrom}}–{{serverTo}} de {{serverTotal}}</span>
      <select class="ti-pager-select" [ngModel]="serverPerPage" (ngModelChange)="changeServerPerPage($event)">
        <option *ngFor="let n of serverPerPageOptions" [value]="n">{{n}} por página</option>
      </select>
      <button type="button" class="btn btn-sm btn-outline-primary" [disabled]="serverPage <= 1" (click)="goToServerPage(1)"><i class="fas fa-angle-double-left"></i></button>
      <button type="button" class="btn btn-sm btn-outline-primary" [disabled]="serverPage <= 1" (click)="goToServerPage(serverPage - 1)"><i class="fas fa-angle-left"></i></button>
      <span class="ti-pager-page">Página {{serverPage}} de {{serverPages}}</span>
      <button type="button" class="btn btn-sm btn-outline-primary" [disabled]="serverPage >= serverPages" (click)="goToServerPage(serverPage + 1)"><i class="fas fa-angle-right"></i></button>
      <button type="button" class="btn btn-sm btn-outline-primary" [disabled]="serverPage >= serverPages" (click)="goToServerPage(serverPages)"><i class="fas fa-angle-double-right"></i></button>
    </div>
  </nb-card-body>
</nb-card>

